import React from 'react';
import Card from '../base/Card';
import Button from '../base/Button';
import './PlaceholderStyles.css';

function AnalyticsPlaceholder() {
  return (
    <div className="placeholder-container">
      <Card className="placeholder-card feature-placeholder">
        <div className="placeholder-icon">📊</div>
        <h2 className="placeholder-title title-1">Analytics</h2>
        <p className="placeholder-description body-text">
          Visualize your focus patterns, track productivity trends, and gain insights
          into your work habits with beautiful charts and statistics.
        </p>
        <div className="placeholder-features">
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Daily focus time tracking</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Weekly/monthly trends</span>
          </div>
          <div className="feature-item">
            <span className="feature-check">✓</span>
            <span className="feature-text">Productivity insights</span>
          </div>
        </div>
        <div className="placeholder-actions">
          <Button variant="primary" showArrow disabled>
            View Analytics
          </Button>
        </div>
        <p className="placeholder-note caption">
          Ready for implementation. Build your analytics dashboard here.
        </p>
      </Card>
    </div>
  );
}

export default AnalyticsPlaceholder;








